import { render, staticRenderFns } from "./screen_dzm.vue?vue&type=template&id=05385e50&scoped=true&"
import script from "./screen_dzm.vue?vue&type=script&lang=js&"
export * from "./screen_dzm.vue?vue&type=script&lang=js&"
import style0 from "./screen_dzm.vue?vue&type=style&index=0&id=05385e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05385e50",
  null
  
)

export default component.exports